import {brands} from "../../config/brand"
import {applyBrandTheme} from "../../utils/theme"

function detectBrand() {
  const host = window.location.hostname.toLowerCase()

  if (host.includes("lni")) {
    return "LNI"
  }
  return "APRILYOS"
}

const state = {
  current: detectBrand()
}

const getters = {
  brand: (state) => brands[state.current],
  brandName: (state) => brands[state.current].name,
  brandColors: (state) => brands[state.current].colors,
  brandFavicon: (state) => brands[state.current].favicon,
  brandTitle: (state) => brands[state.current].title,
  brandMail: (state) => brands[state.current].mailContact,
  brandFeatures: (state) => brands[state.current].features
}

const mutations = {
  SET_BRAND(state, brandKey) {
    if (brands[brandKey]) {
      state.current = brandKey
      applyBrandTheme(brands[brandKey])

      document.title = brands[brandKey].title
      const favicon = document.getElementById("favicon")
      if (favicon) {
        favicon.href = brands[brandKey].favicon
      }
    }
  }
}

const actions = {
  setBrand({ commit }, brandKey) {
    commit("SET_BRAND", brandKey)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/brand.js